import { render, staticRenderFns } from "./TrendBlockDispatch.vue?vue&type=template&id=55a5f773&name=trend-block-dispatch&"
import script from "./TrendBlockDispatch.vue?vue&type=script&lang=js&"
export * from "./TrendBlockDispatch.vue?vue&type=script&lang=js&"
import style0 from "./TrendBlockDispatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports